import './style.scss';
import Swiper from 'swiper';

export function gear_summary_block() {
    const block = document.querySelector('.gear_summary_block');
    if (!block) return;

    new Swiper('.gear-summary-swiper', {
        slidesPerView: 'auto',
        allowTouchMove: true,
    });
}
